import {
  Box,
} from '@mui/material'

import Layout from 'lib/components/Layout'
import LegalDocument from 'lib/components/LegalDocument'

import { PRIVACY } from './content'

const sectionStyles = {
  pt: 18,
  pb: 10,
}

function PrivacyPage() {
  return (
    <Layout>
      <Box
        id="main"
        component="section"
        sx={sectionStyles}
      >
        <LegalDocument {...PRIVACY} />
      </Box>
    </Layout>
  )
}

export default PrivacyPage
